import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Form, FormItem, Input, Select, Option, Message } from "iview";
import "./styles/reset.css";
import "iview/dist/styles/iview.css";
import "./getUserInfo";
import { getLang } from "./utils/auth";

Vue.component("Form", Form);
Vue.component("FormItem", FormItem);
Vue.component("Input", Input);
Vue.component("Select", Select);
Vue.component("Option", Option);
Vue.component("Message", Message);

Vue.prototype.$Message = Message;

//引入多语言支持
import i18n from "./tools/i18n";

if (getLang()) i18n.locale = getLang();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
